import React from 'react'
import {
  Tag,
  Button,
  Input,
  Modal,
  Col,
  Row,
  Tabs,
  List,
  DatePicker,
  message,
  Pagination,
  ConfigProvider
} from 'antd'
import { UserOutlined, AppstoreOutlined, AccountBookOutlined, BellOutlined, ExportOutlined, FileExclamationOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom'
import './index.less'
import { Map, Marker } from 'react-amap';
import zhCN from 'antd/es/locale/zh_CN';
import {getOrderList, getOrderCancel, getOrderAgreere, getOrderDisagreere, getOrderConfirmAlter} from "../../constants/api";
import {removeToken} from "../../utils/cookie";
import {IMAGE_PATH} from "../../constants";

const { TabPane } = Tabs;
const { Search } = Input;
const { CheckableTag } = Tag;

class Orders extends React.Component {
  constructor(props){
    super(props);
  }

  componentWillMount() {
    if (this.props.location.state) {
      this.setState({
        templateId: this.props.location.state.templateId,
        selectedType: this.props.location.state.selectedType
      })
    }
  }
  componentWillReceiveProps(nextProps, nextState, nextContext){
    // console.log('2222222222222222')
    // console.log(this.props.location.state.selectedType)
    // console.log(nextProps.location.state.selectedType)
    if (nextProps.location.state) {
      this.setState({
        templateId: nextProps.location.state.templateId,
        selectedType: nextProps.location.state.selectedType
      }, ()=>{
        this.searchOrders(this.state.current, nextProps.location.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, nextProps.location.state.selectedType, this.state.dateString)
      })
    } else {
      let storage = window.localStorage;
      let templateId = storage.getItem('templateId');
      let selectedType = storage.getItem('selectedType');
      this.setState({
        templateId: templateId,
        selectedType: selectedType
      }, ()=>{
        this.searchOrders(this.state.current, templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, selectedType, this.state.dateString)
      })
    }

  }

  state = {
    confirmLoading: false,//websocket加载控制
    shop: [],//下拉多选门店数据
    shopDefaultName: '',
    shopSelectIds: [],//选中的店ID

    templateIdOption: 0,//临时操作ID


    templateId: 0,//模板ID
    shopId: 0,//门店ID

    dateString: '',//日期
    orderNo: '', //搜索单号
    selectedTag: '全部',//状态value
    selectedStatus: 0,//状态key
    selectedType: 0,//类型
    orders: [],
    orderId: 0,//操作时订单ID
    onCancelVisible: false,//取消订单弹窗
    inputReason: '',//取消原因
    onAgreeVisible: false,//同意弹窗
    onDisAgreeVisible: false,//不同意弹窗
    inputDisagreeReason: '',//不同意原因
    onAlterVisible:false,//确认提醒
    onDeliveryVisible: false,//确认送出
    onReminderVisible: false,//回复用户
    inputReminderContent: '',//回复用户内容
    current: 1,//pageIndex当前页
    total: 0,//数据总数

    onMapVisible: false,
    lat: 0,
    long: 0,
    shopLat: 0,
    shopLong: 0
  }

  componentDidMount() {
    this.getParamsId()
  }

  getParamsId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let shopId = storage.getItem('shopId');

    if (templateId != null) {
      this.setState({
        templateId: templateId,
      })
    }
    if (shopId != null) {
      this.setState({
        shopId: shopId
      })
    }

    //查询订单列表
    this.searchOrders(this.state.current, templateId, shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
  }

  searchOrders(current, templateId, shopId, orderNo, selectedStatus, selectedType, dateString) {
    let templateId_t;
    let shopId_t;
    if (templateId == null) {
      templateId_t = this.state.templateId
    } else {
      templateId_t = templateId
    }
    if (shopId == null) {
      shopId_t = this.state.shopId
    } else {
      shopId_t = shopId
    }
    const _this = this;

    getOrderList({
      orderNo: orderNo,
      orderStatus: selectedStatus,
      orderType: parseInt(selectedType),
      searchDate: dateString,
      shopId: shopId_t,
      templateId: templateId_t,
      pageIndex: current,
      pageSize: 3,
      sortName: "",
      sortType: "",
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            orders: data.data.records,
            total: data.data.total
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axiosD.post(API_ORDER_LIST, {
    //   orderNo: orderNo,
    //   orderStatus: selectedStatus,
    //   orderType: parseInt(selectedType),
    //   searchDate: dateString,
    //   shopId: shopId_t,
    //   templateId: templateId_t,
    //   pageIndex: current,
    //   pageSize: 3,
    //   sortName: "",
    //   sortType: "descending",
    // })
    //     .then(function (response) {
    //       let data = response.data;
    //       console.log('订单列表');
    //       console.log(data.data);
    //       _this.setState({
    //         orders: data.data.records,
    //         total: data.data.total
    //       });
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
  }

  //======================================确认送出弹窗操作start==========================================
  //展示确认送出弹窗
  onShowModalDelivery = (orderId) => {
    console.log('orderId:' + orderId)
    this.setState({
      orderId: orderId,
      onDeliveryVisible: true
    })
  }
  onHandleOkDelivery = () => {
    this.deliveryOrder()
  }
  onHandleCancelDelivery = () => {
    this.setState({
      onDeliveryVisible: false
    })
  }
  //确认送出
  deliveryOrder = () => {
    getOrderConfirmAlter({
      id: this.state.orderId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onDeliveryVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onDeliveryVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axiosD.post(API_ORDER_ALTER, {
    //   id: this.state.orderId,
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onDeliveryVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onDeliveryVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================确认送出弹窗操作end==========================================
  //======================================确认提醒弹窗操作start==========================================
  //展示确认提醒弹窗
  onShowModalAlter = (orderId) => {
    console.log('orderId:' + orderId)
    this.setState({
      orderId: orderId,
      onAlterVisible: true
    })
  }
  onHandleOkAlter = () => {
    this.alterOrder()
  }
  onHandleCancelAlter = () => {
    this.setState({
      onAlterVisible: false
    })
  }
  //确认提醒
  alterOrder = () => {
    getOrderConfirmAlter({
      id: this.state.orderId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onAlterVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onAlterVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ORDER_ALTER, {
    //   id: this.state.orderId,
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onAlterVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onAlterVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================确认提醒弹窗操作end==========================================
  //======================================同意弹窗操作start==========================================
  //展示同意弹窗
  onShowModalAgree = (orderId) => {
    console.log('orderId:' + orderId)
    this.setState({
      orderId: orderId,
      onAgreeVisible: true
    })
  }
  //同意订单
  onHandleOkAgree = () => {
    this.agreeOrder()
  }
  onHandleCancelAgree = () => {
    this.setState({
      onAgreeVisible: false
    })
  }
  //agree订单
  agreeOrder = () => {
    getOrderAgreere({
      id: this.state.orderId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onAgreeVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onAgreeVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ORDER_AGREE, {
    //   id: this.state.orderId,
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onAgreeVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onAgreeVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================同意弹窗操作end==========================================
  //======================================不同意弹窗操作start==========================================
  //展示不同意弹窗
  onShowModalDisAgree = (orderId) => {
    console.log('orderId:' + orderId)
    this.setState({
      orderId: orderId,
      onDisAgreeVisible: true
    })
  }
  //同意订单
  onHandleOkDisAgree = () => {
    this.disagreeOrder()
  }
  onHandleCancelDisAgree = () => {
    this.setState({
      onDisAgreeVisible: false
    })
  }
  //不同意原因
  changeInputDisagreeReason = e => {
    const {value} = e.target;
    this.setState({inputDisagreeReason: value})
  }
  //disagree订单
  disagreeOrder = () => {
    getOrderDisagreere({
      orderId: this.state.orderId,
      reason: this.state.inputDisagreeReason
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onDisAgreeVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onDisAgreeVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axiosD.post(API_ORDER_DISAGREE, {
    //   orderId: this.state.orderId,
    //   reason: this.state.inputDisagreeReason
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onDisAgreeVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onDisAgreeVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================不同意弹窗操作end==========================================
  //======================================取消订单弹窗操作start==========================================
  //展示取消订单弹窗
  onShowModal = (orderId) => {
    console.log(orderId)
    this.setState({
      orderId: orderId,
      onCancelVisible: true
    })
  }
  //取消订单
  onHandleOk = () => {
    this.cancelOrder();
  }
  onHandleCancel = () => {
    this.setState({
      onCancelVisible: false
    })
  }
  //取消原因
  changeInputReason = e => {
    const {value} = e.target;
    this.setState({inputReason: value})
  }
  //取消订单
  cancelOrder = () => {
    getOrderCancel({
      orderId: this.state.orderId,
      reason: this.state.inputReason
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onCancelVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onCancelVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ORDER_CANCEL, {
    //   orderId: this.state.orderId,
    //   reason: this.state.inputReason
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onCancelVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onCancelVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================取消订单弹窗操作end==========================================
  //======================================用户回复弹窗操作start==========================================
  //展示用户回复弹窗
  onShowModalReminder = (remindId) => {
    console.log(remindId)
    this.setState({
      remindId: remindId,
      onReminderVisible: true
    })
  }
  //用户回复
  onHandleOkReminder = () => {
    this.reminderOrder();
  }
  onHandleCancelReminder = () => {
    this.setState({
      onReminderVisible: false
    })
  }
  //用户回复内容
  changeInputReminderContent = e => {
    const {value} = e.target;
    this.setState({inputReminderContent: value})
  }
  //用户回复
  reminderOrder = () => {
    getOrderCancel({
      remindId: this.state.remindId,
      replayContent: this.state.inputReminderContent
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onReminderVisible: false
          }, () => {
            message.success(data.msg)
            this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          this.setState({
            onReminderVisible: false
          }, () => {
            message.error(data.msg)
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_ORDER_CANCEL, {
    //   remindId: this.state.remindId,
    //   replayContent: this.state.inputReminderContent
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onReminderVisible: false
    //       }, () => {
    //         message.success(data.msg)
    //         this.searchOrders(this.state.current, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    //       })
    //     } else {
    //       this.setState({
    //         onReminderVisible: false
    //       }, () => {
    //         message.error(data.msg)
    //       })
    //     }
    //   }
    // })
  }
  //======================================取消订单弹窗操作end==========================================
  onShowModalMap = (location, shopGeo) => {
    let locationArry = location.split(',');
    let long = locationArry[0];
    let lat = locationArry[1];
    console.log(lat)
    console.log(long)
    let shopGeoArry = shopGeo.split(',');
    let longShop = shopGeoArry[0];
    let latShop = shopGeoArry[1];
    console.log(latShop)
    console.log(longShop)
    this.setState({
      onMapVisible: true,
      lat: lat,
      long: long,
      shopLat: latShop,
      shopLong: longShop
    })
  }
  onHandleOkMap = () => {
    this.setState({
      onMapVisible: false
    })
  }
  onHandleCancelMap = () => {
    this.setState({
      onMapVisible: false
    })
  }

  callback(key) {
    console.log(key);
    this.setState({selectedType: key}, ()=>{
      this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, key, this.state.dateString)
    })
  }

  handleTagChange(tag, checked) {
    console.log(tag);
    console.log(checked);
    this.setState({selectedTag: tag})
    if (tag === '全部') {
      this.setState({selectedStatus: 0, current:1}, ()=>{
        this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, 0, this.state.selectedType, this.state.dateString)
      })
    } else if (tag === '进行中') {
      this.setState({selectedStatus: 1, current:1}, ()=>{
        this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, 1, this.state.selectedType, this.state.dateString)
      })
    } else if (tag === '已完成') {
      this.setState({selectedStatus: 2, current:1}, ()=>{
        this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, 2, this.state.selectedType, this.state.dateString)
      })
    } else if (tag === '已取消') {
      this.setState({selectedStatus: 3, current:1}, ()=>{
        this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, 3, this.state.selectedType, this.state.dateString)
      })
    }
  }

  renderList() {
    return (
        <List
            itemLayout="vertical"
            size="large"
            // pagination={{
            //   onChange: page => {
            //     console.log(page);
            //     this.searchOrders(page, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
            //   },
            //   pageSize: 3,
            // }}
            dataSource={this.state.orders}
            renderItem={item => (
                <List.Item
                    key={item.id}
                >
                  <div key={item.id} className="container-order">

                    <div className="container-order-main">
                      <div className="container-order-left">
                        <div className="container-order-left-flag">
                          <span style={{fontSize: 20, fontWeight: 'bold', color: '#1989FA'}}>{item.daySeq}</span>
                        </div>
                        <div className="container-order-left-content">
                          <span style={{fontSize: 15, color: '#7b7b7b'}}>门店: {item.shopNick}</span>
                          {/*<span style={{fontSize: 15, color: '#000000'}}>预计 15:16 送达</span>*/}
                        </div>
                      </div>

                      <div className="container-order-right">
                        <span style={{fontSize: 15, color: '#000000'}}>{
                          item.elemeDatatype === 10? '订单生效':
                              item.elemeDatatype === 12? '商户接单':
                                  item.elemeDatatype === 14? '订单已取消':
                                      item.elemeDatatype === 15? '无效订单':
                                          item.elemeDatatype === 17? '强制无效订单':
                                            item.elemeDatatype === 18? '订单已完成':
                                              item.elemeDatatype === 20? '用户申请取消':
                                                  item.elemeDatatype === 21? '用户撤回取消':
                                                      item.elemeDatatype === 22? '门店拒绝取消':
                                                          item.elemeDatatype === 23? '门店同意取消':
                                                              item.elemeDatatype === 24? '用户申请取消仲裁':
                                                                  item.elemeDatatype === 25? '客服仲裁取消有效':
                                                                      item.elemeDatatype === 26? '客服仲裁取消无效':
                                                    item.elemeDatatype === 30? '用户申请退单':
                                                      item.elemeDatatype === 31? '用户取消退单':
                                                          item.elemeDatatype === 32? '门店拒绝退单':
                                                              item.elemeDatatype === 33? '门店同意退单':
                                                                  item.elemeDatatype === 34? '用户申请退单仲裁':
                                                                      item.elemeDatatype === 35? '客服仲裁退单有效':
                                                                          item.elemeDatatype === 36? '客服仲裁退单无效':
                                                                              item.elemeDatatype === 45? '用户催单':
                                                                                  item.elemeDatatype === 46? '商家回复用户催单':
                                          item.elemeDatatype === 51? '待分配配送商':
                                              item.elemeDatatype === 52? '待分配配送员':
                                                  item.elemeDatatype === 53? '配送员待取餐':
                                                      item.elemeDatatype === 54? '配送员已到店':
                                                          item.elemeDatatype === 55? '配送员配送中':
                                                              item.elemeDatatype === 56? '配送成功':
                                                                  item.elemeDatatype === 57? '配送取消,商户取消':
                                                                      item.elemeDatatype === 58? '配送取消,用户取消':
                                                                          item.elemeDatatype === 59? '配送取消,物流取消':
                                                           item.elemeDatatype === 60? '配送失败,呼叫配送晚':
                                                               item.elemeDatatype === 61? '配送失败,餐厅出餐问题':
                                                                   item.elemeDatatype === 62? '配送失败,商户中断配送':
                                                                       item.elemeDatatype === 63? '配送失败,用户不接电话':
                                                                           item.elemeDatatype === 64? '配送失败,用户退单':
                                                                               item.elemeDatatype === 65? '配送失败,用户地址错误':
                                                                                   item.elemeDatatype === 66? '配送失败,超出服务范围':
                                                                                       item.elemeDatatype === 67? '配送失败,快递员标记异常':
                                                                                           item.elemeDatatype === 68? '配送失败,系统自动标记异常':
                                                                                               item.elemeDatatype === 69? '配送失败,其他异常':
                                                                                                   item.elemeDatatype === 70? '配送超时,系统标记异常':
                                                                                                       item.elemeDatatype === 71? '商家自行配送':
                                                                                                           item.elemeDatatype === 72? '商家不再配送':
                                                                                                               item.elemeDatatype === 73? '只支持在线订单':
                                                    item.elemeDatatype === 74? '超出服务范围':
                                                        item.elemeDatatype === 75? '请求配送过晚, 无法呼叫':
                                                            item.elemeDatatype === 76? '系统异常':

                                              null
                        }
                        </span>
                      </div>
                    </div>

                    <div className="container-order-main"
                         style={{backgroundColor: '#ffffff'}}>
                      <div className="container-order-left">
                        <div className="container-order-left-flag">
                          <UserOutlined />
                        </div>
                        <div className="container-order-left-content">
                          <span style={{fontSize: 16, color: '#000000',fontWeight: 'bold'}}>
                            {item.receiveName}
                            <span style={{fontSize: 15, color: '#1989FA', marginLeft: 8}}>手机号：{item.receiveTel}</span>
                            {/*<span style={{fontSize: 15, color: '#7b7b7b', marginLeft: 8}}>超级会员· 年终奖会员· 近180天第1次下单</span>*/}
                          </span>

                          <span style={{fontSize: 15, color: '#000000'}}>{item.receiveAddress}
                          <span style={{fontSize: 15, color: '#1989FA', marginLeft: 8}}
                               onClick={this.onShowModalMap.bind(this, item.location, item.shopGeo)}>查看地图</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    {/*<div style={{backgroundColor: '#f5f5f5',height: 1}}></div>*/}
                    {/*<div className="container-order-main" style={{backgroundColor: '#ffffff'}}>*/}
                    {/*  <div className="container-order-left">*/}
                    {/*    <div className="container-order-left-flag">*/}
                    {/*      <HistoryOutlined />*/}
                    {/*    </div>*/}
                    {/*    <div className="container-order-left-content">*/}
                    {/*      <span style={{fontSize: 15, color: '#000000'}}>备餐用时 10分56秒</span>*/}
                    {/*    </div>*/}
                    {/*  </div>*/}

                    {/*  <div className="container-order-right-button">*/}
                    {/*    <Button type="primary" shape={'round'}>确认出餐</Button>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                    {
                      item.elemeDatatype === 12 ?
                          <div>
                            <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                              <div className="container-order-left">
                                <div className="container-order-left-flag">
                                  <ExportOutlined />
                                </div>
                                <div className="container-order-left-content">
                                  <span style={{fontSize: 15, color: '#000000', fontWeight: 'bold'}}>待商家配送</span>
                                </div>
                              </div>

                              <div className="container-order-right-button">
                                <Button onClick={this.onShowModalDelivery.bind(this, item.id)}>确认送出</Button>
                              </div>
                            </div>
                            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                          </div> : null
                    }


                    {
                      (item.reminders != null && item.reminders.length > 0) ?
                          item.reminders.map((item) => {
                            return <div key={item.reminderId}>

                              {
                                (item.replyContent == '' || item.replyContent == null) ?
                                    <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                                      <div className="container-order-left">
                                        <div className="container-order-left-flag">
                                          <BellOutlined />
                                        </div>
                                        <div className="container-order-left-content">
                                      <span style={{fontSize: 15, color: '#7b7b7b'}}>{item.addTime}
                                        <span style={{fontSize: 15, color: '#000000', fontWeight: 'bold'}}>用户催单
                                        </span>
                                      </span>
                                        </div>
                                      </div>

                                      <div className="container-order-right-last">
                                        <Button type="primary" onClick={this.onShowModalReminder.bind(this, item.reminderId)}>回复用户</Button>
                                      </div>
                                    </div>
                                    :
                                    <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                                      <div className="container-order-left">
                                        <div className="container-order-left-flag">
                                          <BellOutlined />
                                        </div>
                                        <div className="container-order-left-content">
                                          <span style={{fontSize: 15, color: '#7b7b7b'}}>{item.addTime}
                                            <span style={{fontSize: 15, color: '#000000', fontWeight: 'bold'}}>用户催单，回复：{item.replyContent}
                                          </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                              }
                            </div>
                          })
                          : null
                    }

                    <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                    <div className="container-order-main-p">
                      <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                        <div className="container-order-left">
                          <div className="container-order-left-flag">
                            <AppstoreOutlined />
                          </div>
                          <div className="container-order-left-content">
                            {
                              (item.items != null && item.items.length > 0) ?
                                  <span style={{fontSize: 15, color: '#000000', fontWeight: 'bold'}}>{item.items.length} 件商品</span>
                                  : null
                            }

                            {
                              (item.remark === '' || item.remark === '0') ? null :
                                    <span style={{fontSize: 15, color: '#ef600c',fontWeight: 'bold'}}>
                                      备注:
                                      <span style={{fontSize: 15, color: '#000000', marginLeft: 8}}>{item.remark}</span>
                                    </span>
                            }
                            {
                              (item.cardInfo === '' || item.cardInfo === '0') ? null :
                                  <span style={{fontSize: 15, color: '#ef600c',fontWeight: 'bold'}}>
                                      祝福语:
                                      <span style={{fontSize: 15, color: '#000000', marginLeft: 8}}>{item.cardInfo}</span>
                                    </span>
                            }
                          </div>
                        </div>
                      </div>
                      <div style={{backgroundColor: '#f5f5f5',height: 1, marginLeft: 80}}></div>
                      {
                        (item.items != null && item.items.length > 0) ?
                            item.items.map((item) => {
                              return <div key={item.id}>
                                <div className="container-order-main-p-item">
                                  <div className="container-order-main-p-item-text">
                                    <span style={{fontSize: 13, color: '#7b7b7b'}}>{
                                      item.elemeGroupType === 1 ? item.elemeGroupName :
                                          item.elemeGroupType === 2 ? '配送费等' :
                                              item.elemeGroupType === 3 ? '赠品' :
                                                  item.elemeGroupType === 4 ? '套餐' : null
                                    }</span>
                                      {
                                        item.productName !=null ?
                                            <span style={{fontSize: 15, color: '#000000', marginTop: 5}}>{item.elemeSpecs} {item.productName}</span>
                                            :
                                            <span style={{fontSize: 15, color: '#000000', marginTop: 5}}>{item.description}</span>
                                      }
                                  </div>
                                  <div className="container-order-main-p-item-text-c">
                                    <span style={{fontSize: 15, color: '#000000'}}>x{item.unit}</span>
                                  </div>
                                  <div className="container-order-main-p-item-text-c">
                                    <span style={{fontSize: 15, color: '#000000'}}>{item.price}</span>
                                  </div>
                                </div>
                                <div style={{backgroundColor: '#f5f5f5',height: 1, marginLeft: 80}}></div>
                              </div>
                            })
                            : null
                      }

                      <div className="container-order-main-p-item">
                        <div className="container-order-main-p-item-text2">
                          <span style={{fontSize: 15, color: '#7b7b7b'}}>
                            优惠(商家承担部分 {
                            -(
                                (item.activitysElemePart ? parseFloat(item.activitysElemePart) : 0)
                                +
                                (item.activitysFamilyPart ? parseFloat(item.activitysFamilyPart) : 0)
                                +
                                (item.activitysRestaurantPart ? parseFloat(item.activitysRestaurantPart) : 0)
                            )} | 优惠总计 {-(item.activitysAmount ? parseFloat(item.activitysAmount) : 0)})
                          </span>
                        </div>
                      </div>
                      {
                        (item.activitys != null && item.activitys.length > 0) ?
                            item.activitys.map((item) => {
                              return <div className="container-order-main-p-item" key={item.activityId}>
                                        <div className="container-order-main-p-item-text2">
                                          <span style={{fontSize: 15, color: '#000000'}}>{item.name}</span>
                                        </div>
                                        <div className="container-order-main-p-item-text2">
                                          <span style={{fontSize: 15, color: '#000000'}}>{item.amount}</span>
                                        </div>
                                      </div>
                            })
                            : null
                      }
                    </div>
                    <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                    <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                      <div className="container-order-left">
                        <div className="container-order-left-flag">
                          <AccountBookOutlined />
                        </div>
                        <div className="container-order-left-content">
                          <span style={{fontSize: 15, color: '#000000'}}>顾客实付</span>
                          <span style={{fontSize: 15, color: '#000000'}}>本单预计收入</span>
                        </div>
                      </div>

                      <div className="container-order-right">
                        <span style={{fontSize: 15, color: '#000000'}}>已支付
                          <span style={{fontSize: 15, color: '#000000', fontWeight: 'bold'}}> ¥ {item.orderPayment}</span>
                        </span>
                        <span style={{fontSize: 15, color: '#ff0000',textAlign: 'end', fontWeight: 'bold'}}>¥ {item.actual}</span>
                      </div>
                    </div>
                    <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                    {
                      (item.statusHistory != null && item.statusHistory.length > 0) ?
                          <div className="container-order-main"
                               style={{backgroundColor: '#ffffff'}}>
                            <div className="container-order-left">
                              <div className="container-order-left-flag">
                                <FileExclamationOutlined />
                              </div>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                {
                                  item.statusHistory.map((item) => {
                                    return <div key={item.ordersStatusChangeId}>
                                      {
                                        (item.statusType === 20 || item.statusType === 21 || item.statusType === 22
                                            || item.statusType === 23 || item.statusType === 30 || item.statusType === 31
                                            || item.statusType === 32 || item.statusType === 33) ?
                                            <div className="container-order-left-content">
                                              <span style={{fontSize: 16, color: '#000000',fontWeight: 'bold'}}>
                                                {item.dataTime}
                                                <span style={{fontSize: 15, color: '#1989FA', marginLeft: 8}}>  {item.reason}</span>
                                              </span>
                                            </div>
                                            :null
                                      }
                                    </div>
                                  })
                                }
                              </div>
                            </div>
                          </div> : null
                    }

                    <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                    <div className="container-order-main" style={{backgroundColor: '#ffffff'}}>
                      <div className="container-order-left">
                        <div className="container-order-left-flag">
                        </div>
                        <div className="container-order-left-content">
                          <span style={{fontSize: 15, color: '#7b7b7b'}}>下单时间: {item.orderTimeStr}</span>
                          <span style={{fontSize: 15, color: '#7b7b7b'}}>单号: {item.platformid} (elemedataType:{item.elemeDatatype})</span>
                        </div>
                      </div>

                      <div className="container-order-right-last">
                        {
                          item.dateStatus === 1 ? <Button style={{marginRight: 5}} onClick={this.onShowModalAlter.bind(this, item.id)}>确认提醒</Button>:null
                        }
                        {
                          (item.elemeDatatype === 12 || item.elemeDatatype === 21 || item.elemeDatatype === 22
                              || item.elemeDatatype === 24 || item.elemeDatatype === 26 || item.elemeDatatype === 31 || item.elemeDatatype === 32) ?
                              <Button style={{marginRight: 5}} onClick={this.onShowModal.bind(this, item.id)}>取消订单</Button>
                              :null
                        }
                        {
                          item.elemeDatatype === 30 ? <Button style={{marginRight: 5}} onClick={this.onShowModalAgree.bind(this, item.id)}>同意退单</Button>:null
                        }
                        {
                          item.elemeDatatype === 30 ? <Button style={{marginRight: 5}} onClick={this.onShowModalDisAgree.bind(this, item.id)}>拒绝退单</Button>:null
                        }
                        {
                          item.elemeDatatype === 20 ? <Button style={{marginRight: 5}} onClick={this.onShowModalAgree.bind(this, item.id)}>同意取消单</Button>:null
                        }
                        {
                          item.elemeDatatype === 20 ? <Button onClick={this.onShowModalDisAgree.bind(this, item.id)}>拒绝取消单</Button>:null
                        }
                      </div>
                    </div>
                  </div>
                </List.Item>
            )}
        />
    )
  }

  onDateChange (date, dateString) {
    console.log(dateString)
    this.searchOrders(1, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, dateString)
  }

  onChangePage (page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({current: page}, ()=>{
      this.searchOrders(page, this.state.templateId, this.state.shopId, this.state.orderNo, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
    })
  }

  render() {
    const _this = this
    const tagsData = ['全部', '进行中', '已完成', '已取消'];

    return (
      <div style={{width: "100%"}}>
        <Row className="container">
          <Col span="24" className="container-orders-main">
            <div className="container-orders-top">
              <Row justify="start">
                <Col span={4}>
                  <ConfigProvider locale={zhCN}> <DatePicker onChange = {this.onDateChange.bind(this)}/></ConfigProvider>
                </Col>
                <Col span={6}>
                  <Search placeholder="输入单号查询"
                          onSearch={value => {
                            console.log(value)
                            this.setState({
                              current: 1
                            }, ()=>{
                              this.searchOrders(1, this.state.templateId, this.state.shopId, value, this.state.selectedStatus, this.state.selectedType, this.state.dateString)
                            })
                          }} enterButton />
                </Col>
                <Col span={12} style={{marginLeft: 50}}>
                  <span>状态：</span>{tagsData.map(tag => (
                    <CheckableTag
                        style={{height: '30px', lineHeight: '30px'}}
                        key={tag}
                        checked={this.state.selectedTag === tag}
                        onChange={checked => this.handleTagChange(tag, checked)}
                    >
                      {tag}
                    </CheckableTag>
                ))}
                </Col>
              </Row>
              <Tabs style={{marginTop: 10}} activeKey={this.state.selectedType.toString()} onChange={this.callback.bind(this)}>
                <TabPane tab="全部" key="0">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                      this.renderList() : null
                  }
                </TabPane>
                <TabPane tab="新订单" key="1">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
                <TabPane tab="预订单提醒" key="2">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
                <TabPane tab="配送异常" key="3">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
                {/*<TabPane tab="索赔" key="4">*/}
                {/*  {*/}
                {/*    (this.state.orders != null && this.state.orders.length > 0) ?*/}
                {/*        this.renderList() : null*/}
                {/*  }*/}
                {/*</TabPane>*/}
                <TabPane tab="催单" key="5">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
                <TabPane tab="取消单" key="6">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
                <TabPane tab="退单" key="7">
                  {
                    (this.state.orders != null && this.state.orders.length > 0) ?
                        this.renderList() : null
                  }
                </TabPane>
              </Tabs>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", padding: "0 20px 0 0"}}>
              <Pagination showSizeChanger={false} current={this.state.current}  pageSize={3} total={this.state.total} onChange={this.onChangePage.bind(this)} />
              </div>
            </div>
          </Col>
        </Row>

        <Modal
            title="回复内容"
            visible={this.state.onReminderVisible}
            onOk={this.onHandleOkReminder.bind(this)}
            onCancel={this.onHandleCancelReminder.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <Input.TextArea onChange={this.changeInputReminderContent} placeholder="请输入回复内容"/>
        </Modal>

        <Modal
            title="取消原因"
            visible={this.state.onCancelVisible}
            onOk={this.onHandleOk.bind(this)}
            onCancel={this.onHandleCancel.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <Input.TextArea onChange={this.changeInputReason} placeholder="请输入取消原因"/>
        </Modal>

        <Modal
            visible={this.state.onAgreeVisible}
            onOk={this.onHandleOkAgree.bind(this)}
            onCancel={this.onHandleCancelAgree.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          确定同意吗？
        </Modal>

        <Modal
            title="拒绝原因"
            visible={this.state.onDisAgreeVisible}
            onOk={this.onHandleOkDisAgree.bind(this)}
            onCancel={this.onHandleCancelDisAgree.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <Input.TextArea onChange={this.changeInputDisagreeReason} placeholder="请输入拒绝原因"/>
        </Modal>

        <Modal
            visible={this.state.onAlterVisible}
            onOk={this.onHandleOkAlter.bind(this)}
            onCancel={this.onHandleCancelAlter.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          确定提醒吗？
        </Modal>

        <Modal
            visible={this.state.onDeliveryVisible}
            onOk={this.onHandleOkDelivery.bind(this)}
            onCancel={this.onHandleCancelDelivery.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          确定送出吗？
        </Modal>

        <Modal
            width={'70%'}
            visible={this.state.onMapVisible}
            onOk={this.onHandleOkMap.bind(this)}
            onCancel={this.onHandleCancelMap.bind(this)}
            okText="确认"
            cancelText="取消"
        >
          <div style={{width: '100%', height: '680px'}}>
            <Map zoom={15} amapkey={'e73ee0f829ee336137ca9eabdee6382e'}
                 center={{longitude: this.state.long, latitude: this.state.lat}}>
              <Marker icon={IMAGE_PATH + '/assets/start_point.png'}
                      position={{longitude: this.state.shopLong, latitude: this.state.shopLat}}/>
              <Marker icon={IMAGE_PATH + '/assets/end_point.png'}
                      position={{longitude: this.state.long, latitude: this.state.lat}}/>
            </Map>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withRouter(Orders)




// WEBPACK FOOTER //
// ./src/pages/orders/index.js